import countriesJson from '@/resources/countries.json';

const getDefaultState = () => {
    return {
        locale: null,
        cmsLocaleKey: null,
        currency: countriesJson.find(country => country.iso === process.env.VUE_APP_COUNTRY_ISO).currency.symbol,
        currencyCode: countriesJson.find(country => country.iso === process.env.VUE_APP_COUNTRY_ISO).currency.code,
    };
};

export default {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        resetState(state) {
            Object.assign(state, getDefaultState());
        },

        setLocale(state, payload) {
            state.locale = payload;
        },

        setCmsLocaleKey(state, payload) {
            state.cmsLocaleKey = payload;
        },
    },
    actions: {
        resetLocale({ commit }) {
            commit('resetState');
        },
    },
    getters: {
        getSelectedLocale: state => state.locale,

        getCmsLocaleKey: state => state.cmsLocaleKey,

        getCurrency: state => state.currency,

        getCurrencyCode: state => state.currencyCode,
    },
};
